import { site } from "@/mocks/site";

export default function StatsBand() {
  return (
    <section aria-labelledby="stats-title" className="w-full px-4 md:px-6 pb-12 md:pb-16">
      <div className="rounded-lg bg-accent-50 border border-accent-200 p-6 md:p-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-xs font-medium tracking-widest text-accent-700 uppercase">编辑部的工作方式</p>
            <h2 id="stats-title" className="mt-2 text-2xl md:text-3xl font-bold text-foreground-950">
              我们不追热点，我们追可核对的过程
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            每一条被整理出来的线索，背后都有一份来源记录。这些数字是过去一段时间里我们坚持这件事的痕迹。
          </p>
        </div>

        <dl className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {site.stats.map((item) => (
            <div key={item.label} className="p-4 md:p-5 rounded-lg bg-background-50 border border-accent-100">
              <dt className="text-xs md:text-sm text-foreground-500">{item.label}</dt>
              <dd className="mt-2 text-2xl md:text-3xl font-bold text-primary-600">{item.value}</dd>
            </div>
          ))}
        </dl>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {site.principles.map((item) => (
            <div key={item.title} className="flex gap-3">
              <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-xl`} aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-sm font-bold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}